import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Homeowner from './pages/Homeowner';
import AboutUs from './pages/AboutUs';
import News from './pages/News';
import Events from './pages/Events';
import Documents from './pages/Documents';
import ContactUs from './pages/ContactUs';
import Security from './pages/Security';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="container-fluid">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/homeowner" element={<Homeowner />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/news" element={<News />} />
          <Route path="/events" element={<Events />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/security" element={<Security />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
